import { useState } from 'react';
import type { Article } from '@/types/article';
import ArticleCard from '@/components/base/ArticleCard';

interface LatestFeedProps {
  items: Article[];
}

const PAGE_SIZE = 5;

export default function LatestFeed({ items }: LatestFeedProps) {
  const [visible, setVisible] = useState(PAGE_SIZE);
  const shown = items.slice(0, visible);

  return (
    <div className="flex flex-col gap-3">
      {shown.map((item) => (
        <ArticleCard key={item.id} article={item} />
      ))}

      {visible < items.length ? (
        <button
          type="button"
          onClick={() => setVisible((v) => v + PAGE_SIZE)}
          className="mt-1 flex cursor-pointer items-center justify-center gap-2 rounded-lg border border-background-300 bg-background-50 py-3 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700"
        >
          <i className="ri-add-line"></i>
          加载更多爆料
        </button>
      ) : (
        <p className="py-3 text-center text-xs text-foreground-400">— 已经到底啦 —</p>
      )}
    </div>
  );
}